import { SelectOption } from '@/const/types'

// Program types for degrees (based on https://uatadmin.docscheduler.com/provider/register/medical-specialty)
export const degreeOptions: SelectOption[] = [
	{ label: 'Doctor of Audiology', value: 'Doctor of Audiology' },
	{ label: 'Doctor of Chiropractic', value: 'Doctor of Chiropractic' },
	{ label: 'Doctor of Dental Medicine', value: 'Doctor of Dental Medicine' },
	{ label: 'Doctor of Dental Surgery', value: 'Doctor of Dental Surgery' },
	{ label: 'Doctor of Medicine', value: 'Doctor of Medicine' },
	{ label: 'Doctor of Optometry', value: 'Doctor of Optometry' },
	{ label: 'Doctor of Osteopathic Medicine', value: 'Doctor of Osteopathic Medicine' },
	{ label: 'Doctor of Podiatry', value: 'Doctor of Podiatry' },
	{ label: 'Licensed Professional Counselor', value: 'Licensed Professional Counselor' },
	{ label: 'Licensed Marriage and Family Therapist', value: 'Licensed Marriage and Family Therapist' },
	{
		label: 'Licensed Clinical Social Worker / Licensed Independent Clinical Social Worker',
		value: 'Licensed Clinical Social Worker / Licensed Independent Clinical Social Worker'
	},
	{ label: 'Licensed Professional Clinical Counselor', value: 'Licensed Professional Clinical Counselor' }
]

// Training types for training (based on https://uatadmin.docscheduler.com/provider/register/medical-specialty)
export const trainingTypeOptions: SelectOption[] = [
	{ label: 'Fellowship', value: 'Fellowship' },
	{ label: 'Internship', value: 'Internship' },
	{ label: 'Residency', value: 'Residency' }
]
